import { type FocusCouponId } from '@cart-services/hooks/useFpCategoryPromotionStore'
import { type PropsWithChildren, createContext, useContext, useMemo } from 'react'

export interface PromotionCouponListContextProps {
  scrollMarginTop?: number
  focusCouponId?: FocusCouponId
  onFocusEnd?: () => void
}

const PromotionCouponListContext = createContext<PromotionCouponListContextProps>({})

export const PromotionCouponListProvider = (props: PropsWithChildren<PromotionCouponListContextProps>) => {
  const { scrollMarginTop, focusCouponId, onFocusEnd, children } = props

  const contextValue = useMemo(() => ({
    scrollMarginTop,
    focusCouponId,
    onFocusEnd,
  }), [scrollMarginTop, focusCouponId, onFocusEnd])

  return (
    <PromotionCouponListContext.Provider value={contextValue}>
      {children}
    </PromotionCouponListContext.Provider>
  )
}

export const useContextPromotionCouponList = () => {
  const context = useContext(PromotionCouponListContext)
  if (!context) {
    throw new Error('useContextPromotionCouponList must be used within a PromotionCouponListProvider')
  }
  return context
}
